import { ResourceTag } from '@/types/schema';

export function insertAtExistingKey(
  arr: ResourceTag[],
  newItem: ResourceTag,
  isReplace: boolean = false
): ResourceTag[] {
  const lastKeyIndex = arr.findLastIndex(
    (t) => t.tag_key_id === newItem.tag_key_id
  );
  if (lastKeyIndex === -1) {
    return [...arr, newItem];
  }
  return [
    ...arr.slice(0, lastKeyIndex + (isReplace ? 0 : 1)),
    newItem,
    ...arr.slice(lastKeyIndex + 1),
  ];
}
